import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const actions = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
`
